module.exports = __webpack_public_path__ + "assetst/img/trigger-type-icon.3cc343a4.svg";